import moment from "moment";
import { DAY_OF_WEEK_FORMAT } from "./dates";

export const getFixedOfficeDaysPossible = (): { label: string; value: number }[] => [
  {
    label: moment().startOf("isoWeek").format(DAY_OF_WEEK_FORMAT),
    value: 1,
  },
  {
    label: moment().startOf("isoWeek").add(1, "days").format(DAY_OF_WEEK_FORMAT),
    value: 2,
  },
  {
    label: moment().startOf("isoWeek").add(2, "days").format(DAY_OF_WEEK_FORMAT),
    value: 3,
  },
  {
    label: moment().startOf("isoWeek").add(3, "days").format(DAY_OF_WEEK_FORMAT),
    value: 4,
  },
  {
    label: moment().startOf("isoWeek").add(4, "days").format(DAY_OF_WEEK_FORMAT),
    value: 5,
  },
];
